(function () {
  'use strict';

  function track(event, params) {
    var ta = window.tcbAnalytics;
    if (ta && typeof ta.track === 'function') {
      ta.track(event, params || {});
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, params || {}));
  }

  function contextFrom(el) {
    var root = el && el.closest ? el.closest('[data-tcb-acq]') : null;
    return {
      page_type: root ? root.getAttribute('data-page-type') || 'acquisition' : 'acquisition',
      page_slug: root ? root.getAttribute('data-page-slug') || '' : '',
      equipment_category: root ? root.getAttribute('data-equipment-category') || '' : '',
      industry: root ? root.getAttribute('data-industry') || '' : '',
      geo_type: root ? root.getAttribute('data-geo-type') || '' : '',
      state: root ? root.getAttribute('data-state') || '' : '',
      city: root ? root.getAttribute('data-city') || '' : '',
      cta_location: el && el.getAttribute ? el.getAttribute('data-cta-location') || '' : '',
      lead_type: el && el.getAttribute ? el.getAttribute('data-lead-type') || 'quote' : 'quote'
    };
  }

  function once(el, key) {
    if (!el) return false;
    if (el.getAttribute(key) === '1') return true;
    el.setAttribute(key, '1');
    return false;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var roots = document.querySelectorAll('[data-tcb-acq]');
    roots.forEach(function (root) {
      if (once(root, 'data-tcb-acq-viewed')) return;
      track('quote_page_view', contextFrom(root));
    });
  });

  document.addEventListener('click', function (event) {
    var el = event.target && event.target.closest ? event.target.closest('[data-tcb-acq-event]') : null;
    if (!el) return;
    var name = el.getAttribute('data-tcb-acq-event');
    if (!name) return;
    var params = contextFrom(el);
    var href = el.getAttribute('href') || '';
    if (href.indexOf('/products/') > -1) name = 'product_click_from_quote_page';
    if (href.indexOf('package') > -1) name = el.getAttribute('data-tcb-acq-event') === 'product_click_from_quote_page' ? name : (href.indexOf('/pages/package') > -1 || href.indexOf('facility-package') > -1 ? 'package_click_from_quote_page' : name);
    if (href.indexOf('tel:') === 0) name = 'phone_click_from_quote';
    if (href.indexOf('mailto:') === 0) name = 'email_click_from_quote';
    if (href.indexOf('financ') > -1) name = 'financing_click_from_quote';
    track(name, params);
  });

  function wireForm(form, startEvent, submitEvent, successEvent, errorEvent) {
    if (!form || once(form, 'data-tcb-acq-form-bound')) return;
    var started = false;
    form.addEventListener('input', function () {
      if (started) return;
      started = true;
      track(startEvent, contextFrom(form));
    }, { once: true });
    form.addEventListener('submit', function () {
      track(submitEvent, Object.assign(contextFrom(form), {
        file_uploaded: false,
        lead_type: form.getAttribute('data-lead-type') || 'quote'
      }));
    });
    if (form.querySelector('[data-tcb-contact-posted], .tcb-acq-alert--success')) {
      track(successEvent, contextFrom(form));
    }
    if (form.querySelector('.tcb-acq-alert--error, [role="alert"]')) {
      track(errorEvent, contextFrom(form));
    }
  }

  document.querySelectorAll('[data-tcb-acq-form="quote"]').forEach(function (node) {
    wireForm(node.tagName === 'FORM' ? node : node.querySelector('form'), 'quote_form_start', 'quote_form_submit', 'quote_form_success', 'quote_form_error');
  });
  document.querySelectorAll('[data-tcb-acq-form="rfq"]').forEach(function (node) {
    wireForm(node.tagName === 'FORM' ? node : node.querySelector('form'), 'rfq_upload_start', 'quote_form_submit', 'rfq_upload_success', 'rfq_upload_error');
  });
})();
